import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class SignupService {

  constructor(private http: HttpClient) { }

  getSignups(queryParams: any) {
    const params = new HttpParams({fromObject: queryParams});
    return this.http.get(urls.API_URL + urls.SIGNUPS, {params})
      .pipe(catchError(errorHandl));
  }

  updateStatus(id: any, payload: any) {
    return this.http.patch(urls.API_URL + urls.SIGNUPS + `/${id}`, payload)
      .pipe(catchError(errorHandl));
  }

  signup(payload: any) {
    return this.http.post(urls.API_URL + urls.SIGNUPS, payload)
      .pipe(catchError(errorHandl));
  }

  bullkUpdate(payload: any) {
    return this.http.post(urls.API_URL + urls.SIGNUPS + '/bulk-update', payload)
      .pipe(catchError(errorHandl));
  }

}
